export default {
    CREATE_CARD: '/create-card',
    CREATE_PIN_PAD: '/create-pin-pad',
    COMPLETE_PIN_PAD: '/complete-pin-pad',
    // AWS Lambda function will catch POST request from PaySecure and send GET request to /complete-pin-pad
    COMPLETE_PIN_PAD_REDIRECT_AWS: '/complete-pin-pad-post',
};
